import {
  getCountryMappings,
  AllCountriesDataProps
} from '@uma/react-commons/dist/index';

/**
 * Checks if the Subscriptions page should be visible for the current country.
 * @returns {Promise<boolean>} - True if the page should be active, false otherwise.
 */
const isSubscriptionsPageActive = async (): Promise<boolean> => {
  try {
    const result = await getCountryMappings(
      AllCountriesDataProps.IsSubscriptionsPageActive
    );

    if (typeof result !== 'boolean') {
      throw new Error(
        `Error from getCountryMappings returned a non-boolean value: ${result}`
      );
    }

    return Boolean(result);
  } catch (error) {
    console.error(
      'Error checking Subscriptions page availability. Defaulting to show the page:',
      error
    );
    return true;
  }
};

export default isSubscriptionsPageActive;
